import { render } from "./QuickMatrixCard1.vue?vue&type=template&id=5347f6b1&scoped=true"
import script from "./QuickMatrixCard1.vue?vue&type=script&lang=js"
export * from "./QuickMatrixCard1.vue?vue&type=script&lang=js"

import "./QuickMatrixCard1.vue?vue&type=style&index=0&id=5347f6b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5347f6b1"]])

export default __exports__